import React, { useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthContext } from "../config/AuthContext";
import Login from "../newView/Login";
import { Layout } from 'antd';
import { Content } from "antd/es/layout/layout";
import AppHeader from "./metadata/components/AppHeader";
import AppMetadataRoutes from "./routes/AppMetadataRoutes";
import AppFooter from "./components/AppFooter";
import AppSider from "./metadata/components/AppSider";
import AppBreadcrumb from "./components/AppBreadcrumb";

const Metadata = () => {
    const { isLoggedIn, setBreadCrumb } = useContext(AuthContext);

    React.useEffect(() => {
        setBreadCrumb([{ nom: 'Metadata', nav: '/metadata' }], true);
    }, []);

    if (isLoggedIn) {
        return (
            <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <AppHeader />
                <Content style={{ padding: '0 48px', flex: '1 0 auto' }}>
                    <AppBreadcrumb />
                    <Layout style={{ padding: '24px 0', background: '#fff', borderRadius: '8px' }}>
                        <AppSider currentVal={0} setPantalla={() => { }} />
                        <Content style={{ padding: '0 24px', minHeight: 280 }}>
                            <AppMetadataRoutes />
                        </Content>
                    </Layout>
                </Content>
                <AppFooter />
            </Layout>
        );
    } else {
        return (
            <Login />
        );
    }
};

export default Metadata;
